// The main store used for the Summary Page
import {DateTime as dt} from "luxon";
import axios from "axios";
import {captureException} from "@sentry/browser";

export default {
	namespaced: true,
	state: () => ({
		summary: {},
		summaryError: false,
	}),
	
	getters: {
		formatInstallDate:(state, getters) => () => {
			if (state.summary && state.summary.arrivalDate && state.summary.arrivalTime){
				return dt.fromFormat(state.summary.arrivalDate, 'L/d/yyyy').toFormat('DDD, ') + getters.formatInstallTime(state.summary.arrivalTime)
			}
			return 'Self Install'
		},
		formatInstallTime: (state, getters, rootState, rootGetters) => (timeFrame = null) => {
			return rootGetters['Buyflow/finalize/formatInstallTime'](timeFrame)
		},
	},

	mutations: {
		SET_SUMMARY (state, payload) {
			state.summary = { ...payload }
		},
		SET_SUMMARY_ERROR (state, payload) {
			state.summaryError = payload
		},
	},

	actions: {
		completeOrder ({ commit }) {
			commit('Buyflow/COMPLETE_ORDER', null, ROOT)
			commit('SET_METADATA', {
				isCurrentCustomer: true,
				customerState: 'current',
			}, ROOT)
		},
		orderSummary ({ dispatch, commit, rootState, rootGetters }) {
			commit('SET_SUMMARY_ERROR', false)
			dispatch('toggleLoading', { value: true }, ROOT)

            const planId = rootGetters['BroadbandLabels/getProductLabelData'](rootGetters['Buyflow/internet/selectedService']?.name)

			console.log('plan id', planId? planId?.labels[0]?.labelFrnIdentifier : 'not available')

            //Created a check to validate the planId exists. If it doesn't exist, in the case of an already created order, we pass along not avaiable.
			return dispatch('Buyflow/_checkout_completeOrder', {
                labelParameters: rootState.BroadbandLabels.labelRequest || [], 
                planId: planId? planId?.labels[0]?.labelFrnIdentifier:'not available'
            }, ROOT)

				.then(r => {
					commit('SET_SUMMARY', r.data.data)
					return dispatch('Buyflow/_formatCartData', r.data.data.receipt, ROOT)
                        .then((cartData) => {
                            if(r.data.data.id.startsWith('#')){
                                dispatch("Buyflow/_fetchTaxes", null, ROOT)
                                    .then(futureStatement => dispatch('Buyflow/receipt/updateCart', {
                                        ...cartData,
                                        taxes:futureStatement.taxFees,
                                    }, ROOT))
                            }else {
                                dispatch("Buyflow/_futureStatement", {accountNumber: r.data.data.id}, ROOT)
                                    .then(futureStatement => dispatch('Buyflow/receipt/updateCart', {
                                        ...cartData,
                                        taxes:futureStatement.taxFees,
                                    }, ROOT))
                            }
                        })
						.then(() => {
							if (rootState.clearlinkOfferId && rootState.clearlinkId) {
								return axios.post('/api/clearlink/submit', {
									offer_id: rootState.clearlinkOfferId,
									transaction_id: rootState.clearlinkId
								}).catch(e => {
									captureException(e)
								})
							}
						})
				})
				.catch(e => {
					if (e.response?.data?.errors[0] === "Order has already been placed for your address"){
						commit('SET_SUMMARY_ERROR', true)
					} else {
						dispatch('togglePopup', {
							type: 'COMMON/ERRORS/UNEXPECTED',
							error: e,
					}, ROOT)
					}
				})
				.finally(() => {
					commit('Buyflow/SET_READY', null, ROOT)
					dispatch('setClearlinkId', {clearlinkId: '', clearlinkOfferId: ''} ,ROOT)
					dispatch('toggleLoading', { value: false }, ROOT)
				})
		},
	},
}
